import { CookieConsentType } from './models/cookie-consent-type.enum';
import { ConcurrencyOption } from './types/concurrency-option.type';
import { CookieConsentOption } from './types/cookie-consent-option.type';
import { Extensions } from './types/extensions.type';
import { QualityOption } from './types/quality-option.type';

export const EXTENSIONS: Extensions = {
  'image/png': 'png',
  'image/jpeg': 'jpg',
};

export const QUALITY_OPTIONS: QualityOption[] = [
  { value: { mime: 'image/jpeg', quality: 1 }, text: 'JPG: High Quality' },
  {
    value: { mime: 'image/jpeg', quality: 0.8 },
    text: 'JPG: Medium Quality',
  },
  { value: { mime: 'image/jpeg', quality: 0.6 }, text: 'JPG: Low Quality' },
  { value: { mime: 'image/png', quality: 1 }, text: 'PNG: Lossless' },
];

export const CONCURRENCY_OPTIONS: ConcurrencyOption[] = [
  { value: 32, text: '32 workers', icon: 'lightning-charge' },
  { value: 16, text: '16 workers', icon: 'fast-forward' },
  { value: 8, text: '8 workers', icon: 'play' },
  { value: 4, text: '4 workers', icon: 'hourglass-split' },
  { value: 1, text: '1 workers', icon: 'hourglass' },
];

export const COOKIE_CONSENT_OPTIONS: CookieConsentOption[] = [
  { value: CookieConsentType.Preferences, text: 'Preferences' },
  { value: CookieConsentType.Statistics, text: 'Statistics' },
  { value: CookieConsentType.Marketing, text: 'Marketing' },
];

export const STATISTICS_COOKIE_NAME_PREFIXES = [
  '_ga_',
  '_ga',
  '_gcl_au',
  '_utma',
  '_utmb',
  '_utmc',
  '_utmt',
  '_utmv',
  '_utmx',
  '_utmz',
] as const;
